// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__1X6Wu","validationTips":"StatementDescriptor_validationTips__2EfbW"};